import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const WarehouseSchema = Yup.object().shape({
  name: Yup.string().min(1).required('Name is required'),
  warehouseCode: Yup.string().min(1).required('Name is required'),
  // warehouseCity: Yup.string().min(1).required('Name is required'),
  stateCode: Yup.string().min(1).required('Name is required'),
  contactPersonName: Yup.string().min(1).required('Name is required'),
  warehouseAddress: Yup.string().min(1).required('Name is required'),
  contactPersonPhoneNo: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  contactPersonEmail: Yup.string().min(1).required('Email is required'),
  type: Yup.string().min(1).required('First name is required'),
  status: Yup.boolean().required('Last name is required'),
  rackCount: Yup.number().min(1).required('Last name is required'),
});

export type WarehouseDataType = Yup.InferType<typeof WarehouseSchema>;

type InitialValues = {
  name: string;
  warehouseCode: string;
  // warehouseCity: string;
  stateCode: string;
  contactPersonName: string;
  warehouseAddress: string;
  contactPersonPhoneNo: string;
  contactPersonEmail: string;
  type: string;
  status: boolean;
  rackCount: string;
};

export const WarehouseInitialValues: InitialValues = {
  name: '',
  warehouseCode: '',
  // warehouseCity: '',
  stateCode: '',
  contactPersonName: '',
  warehouseAddress: '',
  contactPersonPhoneNo: '',
  contactPersonEmail: '',
  type: '',
  status: false,
  rackCount: '',
};

export interface IWarehouseResponse {
  contactEmail: string;
  contactPerson: string;
  contactPhoneNo: string;
  createdBy: string;
  createdDate: string;
  createdRackCount: number;
  id: string;
  lastUpdatedBy: string;
  name: string;
  rackCount: number;
  status: boolean;
  type?: string | null;
  updatedDate?: string | null;
  warehouseAddress: string;
  warehouseCity: string;
  warehouseCode: string;
}

// export interface IWarehouseRequest {
//   name: string;
//   // warehouseCode: string;
//   stateCode: number;
//   warehouseCity: string;
//   contactPersonName: string;
//   warehouseAddress: string;
//   contactPersonPhoneNo: string;
//   contactPersonEmail: string;
//   type: string;
//   status: boolean;
//   rackCount: number;
// }

export interface IWarehouseRequest {
  contactPersonPhoneNo: string;
  stateCode: number;
  type: string;
  status: boolean;
  name: string;
  warehouseCode: string;
  warehouseAddress: string;
  rackCount: number;
  contactPersonName: string;
  contactPersonEmail: string;
}

export interface IWarehouseListData {
  contactEmail: string;
  contactPerson: string;
  contactPhoneNo: string;
  createdBy: string;
  createdDate: string;
  createdRackCount: number;
  id: string;
  lastUpdatedBy: string;
  name: string;
  rackCount: number;
  status: boolean;
  type?: string | null;
  updatedDate?: string | null;
  warehouseAddress: string;
  warehouseCity: string;
  warehouseCode: string;
}

export interface IWarehouseRequestResponse {
  records: IWarehouseListData[];
  totalPages: number;
  totalRecords: number;
}

export interface IWarehouseStateCodes {
  name: string;
  code: number;
}
